import React from 'react';

export interface RenderProps {
  imgProps: any;
}

interface ISimplePictureProps {
  src: string;
  resize: ({ url, format } : { url: string; format: string}) => string;
  formats?: string[];
  className?: string;
  render: (opts: RenderProps) => React.ReactElement<{}>;

}

const SimplePicture = ({
  className = '',
  src,
  formats = ['jpeg', 'webp'],
  render,
  resize,
}: ISimplePictureProps) => (
  <picture className={className}>
    {
     formats.map((format) => (
       <source
         key={format}
         srcSet={resize({ url: src, format })}
         type={`image/${format}`}
       />
     ))
   }
    {render({
      imgProps: {
        src: resize({ url: src, format: formats[0] })
      }
    })}
  </picture>
);

export default SimplePicture;
